import { z } from 'zod/v3';
import {
  systemClassifierCodes,
  SystemClassifierSchema,
} from '../../systemClassifier/schema/SystemClassifierSchema';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './ConfigurationSchema.translations.json';
import { transformNullish } from '../../common/utils/schema/transformers/transformNullish';

const { addTranslations, t } = i18nNsFactory('configuration-schema');
addTranslations(translations);

const environments = ['local', 'dev', 'test', 'prod'] as const;

export const ConfigurationSchema = z.object({
  environment: z.enum(environments).or(z.literal('')),
  timezone: z.string().default('Europe/Tallinn'),
  systemClassifiers: SystemClassifierSchema?.array().superRefine(
    (data, ctx) => {
      for (const code of systemClassifierCodes) {
        if (!data.find((c) => c.code === code)) {
          ctx.addIssue({
            code: 'custom',
            message: t('validation.code.missing', { code }),
            path: ['systemClassifiers'],
          });
        }
      }
    },
  ),
  airflowUrl: transformNullish(z.string().url(), ''),
  atlasDocsUrl: transformNullish(z.string().url(), ''),
  grafanaUrl: transformNullish(z.string().url(), ''),
  supersetUrl: transformNullish(z.string().url(), ''),
});
